var map = {
	"./en_US.jpg": "9969",
	"./es_US.jpg": "cdf5",
	"./fr_FR.jpg": "c3c3",
	"./germany.jpg": "8a5d",
	"./italy.jpg": "12db",
	"./russia.jpg": "de9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b9f";